module.exports = __webpack_public_path__ + "static/media/group_button.33a705b6.svg";